require.register("description/util/parser", function(exports, require, module){
  $0
  
});

